import React from '../../_snowpack/pkg/react.js';
import styled, { keyframes } from '../../_snowpack/pkg/styled-components.js';
const realSize = 40;
const spin = keyframes(["0%{transform:rotate(0deg);stroke-dashoffset:", ";}50%{transform:rotate(720deg);stroke-dashoffset:", ";}100%{transform:rotate(1080deg);stroke-dashoffset:", ";}"], 0.66 * realSize, 3.14 * realSize, 0.66 * realSize);
const Outer = styled.div.withConfig({
  displayName: "loading-spinner__Outer",
  componentId: "sc-1p3feq6-0"
})(["display:inline-flex;align-items:center;"]);
const SVG = styled.svg.withConfig({
  displayName: "loading-spinner__SVG",
  componentId: "sc-1p3feq6-1"
})(["width:", ";height:", ";circle{fill:transparent;stroke:", ";stroke-width:", ";stroke-linecap:round;stroke-dasharray:", ";transform-origin:", " ", " 0;animation:", " 2s linear infinite;}"], p => `${p.viewSize}px`, p => `${p.viewSize}px`, p => p.color, p => p.strokeSize ? p.strokeSize : p.viewSize / 10, p => p.size * 3.14, p => `${p.sizeHalf}px`, p => `${p.sizeHalf}px`, spin);
const Children = styled.span.withConfig({
  displayName: "loading-spinner__Children",
  componentId: "sc-1p3feq6-2"
})(["display:inline-block;margin-left:15px;font-size:", ";"], p => p.size ? `${p.size * 0.75}px` : '1em');

function LoadingSpinner(props) {
  const {
    color = 'currentColor',
    size = 0,
    strokeSize,
    children,
    className
  } = props;
  const viewSize = size !== null && size !== void 0 ? size : realSize;
  return /*#__PURE__*/React.createElement(Outer, {
    className: className,
    "data-cypress": "loading-spinner"
  }, /*#__PURE__*/React.createElement(SVG, {
    color: color,
    viewSize: viewSize,
    size: realSize,
    strokeSize: strokeSize,
    sizeHalf: realSize / 2,
    spin: spin,
    viewBox: `0 0 ${realSize} ${realSize}`,
    x: "0px",
    y: "0px"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "18"
  })), children && /*#__PURE__*/React.createElement(Children, {
    size: size
  }, children));
}

export default LoadingSpinner;